__turbopack_context__.v({
  "box": "stat-box-module__fOUEGa__box",
  "label": "stat-box-module__fOUEGa__label",
  "skeleton": "stat-box-module__fOUEGa__skeleton",
  "sub": "stat-box-module__fOUEGa__sub",
  "value": "stat-box-module__fOUEGa__value",
});
